/*
 * @Author: wangshengqiang
 * @Date: 2021-05-07 11:35:10
 * @LastEditTime: 2021-05-14 15:27:45
 * @LastEditors: wangshengqiang
 * @Description: a
 */
export const PREMIUM = 'PREMIUM';
export const CALCULATED_PREMIUM = 'CALCULATED_PREMIUM';
export const CLAUSE_CHECKED = 'CLAUSE_CHECKED';
export const PLAN_ID = 'PLAN_ID';
export const FETCH_STORE = 'FETCH_STORE';
export const POLICY_INFO = 'POLICY_INFO';
export const HAD_NOTICE = 'HAD_NOTICE';
export const OPEN_RENEWAL = 'OPEN_RENEWAL';
export const FORM_KEY = 'formValues';